import { Typography, Card, CardContent, CardActions, Stack, Box } from '@mui/material';
import { StarOutlined as StarOutlinedIcon } from '@mui/icons-material';
import { formatDate } from '../../lib/format';
import { navigate } from '../../lib/navigation';
import Badge from '../../components/Badge';
import Button from '../../components/Button';
import PortfolioThumbnail from '../../components/PortfolioThumbnail';

function PortfolioCard({ item }) {
  return (
    <Card variant="outlined" sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <PortfolioThumbnail item={item} height={180} />
      <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        <Stack direction="row" spacing={0.5} sx={{ alignItems: 'center' }}>
          <Typography variant="h6" noWrap sx={{ lineHeight: 1.3, height: '1.3em', flexGrow: 1 }}>
            {item.title}
          </Typography>
          {item.featured && <StarOutlinedIcon fontSize="small" sx={{ color: 'warning.main' }} titleAccess="Featured" />}
        </Stack>
        {item.description ? (
          <Typography
            color="text.secondary"
            sx={{
              mb: 1,
              whiteSpace: 'pre-line',
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              lineHeight: 1.5,
              height: '3em',
            }}
          >
            {item.description}
          </Typography>
        ) : (
          <Typography sx={{ mb: 1, fontStyle: 'italic', color: 'text.disabled', lineHeight: 1.5, height: '3em' }}>
            No description added
          </Typography>
        )}
        <Stack direction="row" spacing={1} useFlexGap sx={{ flexWrap: 'wrap' }}>
          <Badge>{item.type}</Badge>
          <Badge tone={item.visibility === 'Public' ? 'success' : 'neutral'}>{item.visibility}</Badge>
          {(item.tags || []).map((tag) => (
            <Badge key={tag}>{tag}</Badge>
          ))}
        </Stack>
        {item.publishedAt && (
          <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
            Published {formatDate(item.publishedAt)}
          </Typography>
        )}
        <Box sx={{ flexGrow: 1 }} />
      </CardContent>
      <CardActions>
        {item.contentUrl ? (
          <Button variant="primary" href={item.contentUrl} target="_blank" rel="noreferrer">
            View sample
          </Button>
        ) : (
          <Button variant="secondary" disabled>
            View sample
          </Button>
        )}
        <Button variant="secondary" onClick={() => navigate(`/dashboard/portfolio/edit/${item.id}`)}>
          Edit
        </Button>
      </CardActions>
    </Card>
  );
}

export default PortfolioCard;
